import { RootState } from './store';

export const selectFirstIncomingParticipant = (state: RootState) => state.incomingParticipants?.[0] || {};
export const selectAllParticipants = (state: RootState) => state.incomingParticipants;
export const getLocalParticipantId = (state: RootState) => state.localParticipantId;
